import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { HandleError, HttpErrorHandler } from './http-error-handler.service';
import { HelperService } from './helper.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from './translate.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	API_URL: string = '';
	private handleError: HandleError;

	constructor(private _http: HttpClient,
		private messageService: MessageService,
		private translate: TranslateService,
		httpErrorHandler: HttpErrorHandler,
		private spinner: NgxSpinnerService,
		private helperService: HelperService,
		private router: Router
	) {
		this.API_URL = environment.API_URL;
		this.handleError = httpErrorHandler.createHandleError('ApiService');
	}

	/*
  additionalParam = {
	skipOnBehalf: true
  }
  */
	// resolveOnError: settle the promise on failure too, so the caller can react instead of
	// hanging. Opt-in — every other caller keeps the "only resolves on success" behaviour.
	get(endpoint: string = '', additionalHeader: any = {}, additionalParam: any = {}, resolveOnError: boolean = false) {
		this.loaderStart()

		// let customParams = {};
		// if(additionalParam?.skipOnBehalf !== undefined) {
		//   customParams = {
		//     skipOnBehalf: additionalParam?.skipOnBehalf
		//   }
		// }

		return new Promise((resolve, reject) => {
			this._http.get(this.API_URL + endpoint, { headers: additionalHeader, params: additionalParam }).pipe(
				catchError(this.handleError(endpoint, []))
			).subscribe({
				next: (res: any) => {
					this.loaderEnd();

					this.helperService.printLog("res of " + endpoint, res)
					this.stickyMsgHandler(res);
					if (!!res.success && res.success) {
						resolve(res);
					} else {
						let isReturn = this.customErrorHandle(endpoint, res);
						if (isReturn || resolveOnError) {
							resolve(res);
						}
					}
				},
				error: (error) => {
					this.loaderEnd();
					reject(error);
				},
				// handleError swallows a transport/5xx failure into an empty observable, so
				// completing without emitting is the only failure signal available here.
				// No-op after a next that already resolved.
				complete: () => {
					if (resolveOnError) { resolve(null); }
				}
			});
		});
	}

	post(endpoint: string = '', postData:any = {}, fileArrayKeys:any=[]) {
		this.loaderStart();
				
		// For File Array - START
		let formData: FormData = new FormData();
		if(fileArrayKeys?.length > 0) {
			for(var key in postData) {
				var value = postData[key];

				if(fileArrayKeys.indexOf(key) > -1) {
					for(var keySub in value) {
						formData.append(key+'[]', value[keySub]);
					}
				} else {
					formData.append(key, value);
				}
			}
		} else {
			formData = postData;
		}
		// For File Array - END

		return new Promise((resolve, reject) => {
			this._http.post(this.API_URL + endpoint, formData).pipe(
				catchError(this.handleError(endpoint, []))
			).subscribe((res: any) => {
				this.loaderEnd();

				this.helperService.printLog("res of " + endpoint, res)
				this.stickyMsgHandler(res);
				if (!!res.success && res.success) {
					resolve(res);
				} else {
					let isReturn = this.customErrorHandle(endpoint, res);
					if (isReturn) {
						resolve(res);
					}
				}
			}, error => {
				this.loaderEnd();
				reject(error);
			});
		});
	}

	put(endpoint: string = '', postData = {}) {
		this.loaderStart()
		return new Promise((resolve, reject) => {
			this._http.put(this.API_URL + endpoint, postData).pipe(
				catchError(this.handleError(endpoint, []))
			).subscribe((res: any) => {
				this.loaderEnd();
				this.helperService.printLog("res of --- " + endpoint, res)
				this.stickyMsgHandler(res);
				if (!!res.success && res.success) {
					resolve(res);
				} else {
					let isReturn = this.customErrorHandle(endpoint, res);
					if (isReturn) {
						resolve(res);
					}
				}
			}, error => {
				this.loaderEnd();
				reject(error);
			});
		});
	}

	delete(endpoint: string = '') {
		this.loaderStart();
		return new Promise((resolve, reject) => {
			this._http.delete(this.API_URL + endpoint).pipe(
				catchError(this.handleError(endpoint, []))
			).subscribe((res: any) => {
				this.loaderEnd();

				this.helperService.printLog("res of " + endpoint, res)
				this.stickyMsgHandler(res);
				if (res.success !== undefined && !res.success) {
					let isReturn = this.customErrorHandle(endpoint, res);
					if (isReturn) {
						resolve(res);
					}
				} else {
					resolve(res);
				}
			}, error => {
				this.loaderEnd();
				reject(error);
			});
		});
	}

	loaderStart() {
		this.helperService.requestCount++;
		this.spinner.show();
	}

	loaderEnd() {
		// this.helperService.requestCount--;
		// if(this.helperService.requestCount <= 0) {
		// }
		this.spinner.hide();
	}

	stickyMsgHandler(res: any = {}) {
		if(!!res?.display) {
			if(res?.display == 'regular' && res?.success) {
				this.messageService.add({ severity: 'success', summary: '', detail: `${this.translate.fnTransform(res.message_code)}` });
			} else if (res?.display == 'sticky') {
				this.helperService.stickyMessageEmitter.next(res.message);
			}
		}
	}

	customErrorHandle(endpoint: string = '', error: any = {}) {
		// this.router.navigate(['/509']);
		const err = (!!error) ? error : {};
		const message = (!!err.message_code) ? this.translate.fnTransform(err.message_code) : `server returned code ${error.status} with body "${error.error}"`;

		if (!!err.message && err.message == "Unauthenticated.") {
			this.router.navigate(['/login']);
			return false;
		}

		if (!!err.message_code && ['form_validation'].indexOf(err.message_code) > -1) {
			this.helperService.errorListEmitter.next(err.errors);
			return false;
		} else if (!!err.message_code && ['mobile_in_use', 'mobile_already_registred'].indexOf(err.message_code) > -1) {
			return true;
		} else {
			this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `${message}` });
			return false;
		}
	}

}
